module.exports = __webpack_public_path__ + "static/media/ic-nav-event-home.3e4fa847.svg";